/* eslint-disable max-len */
/**
 * Polish translations.
 */
export default {
  ACTION: {
    CANCEL: 'Anuluj',
    CONFIRM: 'Potwierdzenie',
    CONFIRM_POLL_RESPONSE: 'Potwierdź odpowiedź',
    CONTINUE: 'Kontynuuj',
    COPY: 'Kopia',
    DELETE: 'Usuń',
    DELETE_MESSAGE: 'Usuń wiadomość',
    EDIT: 'Edytuj',
    FINISH: 'Zakończ',
    HIDE_ANSWERS: 'Ukryj odpowiedzi',
    LETS_GET_STARTED: 'Jasne, zaczynajmy.',
    MARK_AS_UNREAD: 'Oznacz jako nieprzeczytane',
    REPLY: 'Odpowiedź',
    SEE_ANSWERS: 'Zobacz odpowiedzi',
    START_SURVEY: 'Rozpocznij ankietę'
  },
  ERROR: {
    ASSET_SIZE_EXCEEDED: 'Maksymalny rozmiar pliku to {size}MB',
    CLASSIFICATION_ALREADY_IN_USE:
      'Ankieta wygasła, ponieważ dla tej kategorii istnieje już kampania.',
    ERROR_CREATING_NEW_SUGGESTION: 'Błąd podczas tworzenia nowej oferty',
    ERROR_SAVING_PRODUCT_REVIEW: 'Błąd podczas zapisywania oceny produktu',
    ERROR_SENDING_MESSAGE: 'Błąd wysyłania wiadomości',
    ERROR_SUBMITTING_SURVEY: 'Błąd podczas przesyłania ankiety',
    IMAGE_SIZE_EXCEEDED: 'Maksymalny rozmiar obrazu to {size}MB',
    MESSAGE_ALREADY_READ:
      'Tej wiadomości nie można już edytować, ponieważ została już przeczytana.',
    UPLOADED_ASSETS_EXCEED: 'Maksymalna liczba plików wynosi {limit}',
    VIDEO_SIZE_EXCEEDED: 'Maksymalny rozmiar filmu to {size}MB'
  },
  HEADER: {},
  LABEL: {
    ACTIONS: 'Działania',
    ADDITIONAL_COMMENTS_QUESTION: 'Dodatkowe uwagi?',
    ANSWERED_ON: 'Odpowiedziano na {date}',
    CONTACT_OWNER: 'Coś poszło nie tak. Skontaktuj się ze swoim menedżerem',
    CREATE_NEW_CAMPAIGN_SUGGESTION:
      'Kliknij tutaj, aby wygenerować nową ofertę',
    EDITED: 'Edytowano',
    EXPIRED_ON: 'Wygasła {date}',
    LAST_READ: 'Ostatni odczyt',
    POLL_CAMPAIGN_EXPIRED: 'ℹ️ Oferta wygasła',
    POLL_CAMPAIGN_FOOTER:
      'ℹ️ Akceptując, kampania zostanie utworzona i rozpocznie się jutro.\nOtrzymasz również jutro wiadomość z plakatem do udostępnienia.\nTa oferta będzie dostępna przez 3 dni.',
    QUANTITY: 'Ilość',
    REACT: 'React',
    REACTIONS: 'Reakcje',
    RESPOND_BY: 'Odpowiedz do {date}',
    SEE_PRODUCTS: 'Zobacz produkty',
    SEEN: 'Widziany',
    SELECT_ADDRESS: 'Wybierz adres',
    SELECT_ONE_OPTION: 'Wybierz opcję',
    SELECT_ONE_OR_MORE_OPTION: 'Wybierz jedną lub więcej opcji',
    SENT: 'Wysłany',
    SWIPE_TO_CANCEL: 'Przesuń, aby anulować',
    TYPE_NEW_MESSAGE: 'Napisz nową wiadomość',
    VOICE_MESSAGE: 'Wiadomość głosowa'
  },
  SENTENCE: {
    CONFIRM_POLL_INTERNAL_ORDER:
      'Ta akcja potwierdzi zamówienie i nie będzie można zmienić odpowiedzi. Czy na pewno chcesz kontynuować?',
    DELETE_MESSAGE_CONFIRM: 'Czy na pewno chcesz usunąć tę wiadomość?',
    GIVE_OPINION_ABOUT_PRODUCT:
      'Czy możesz podzielić się z nami swoją opinią na temat tego produktu?',
    MESSAGE_DELETED: 'Ta wiadomość została usunięta'
  },
  SUCCESS: {},
  TOOLTIP: {}
};
